/* Imprimini v2 — imx-motion.js
 * Un seul petit fichier, sans librairie :
 * 1) la logique d'achat reprise de la v1 (assets/imp.js) : dates, Noël, galerie, formulaires, barre collante ;
 * 2) les animations : apparition au scroll, titres en masque, ticket de la bannière, démo, étapes, reçu,
 *    inclinaison 3D, barre de lecture.
 * Règles : on n'anime que transform et opacity ; tout est coupé si le visiteur demande moins d'animations.
 */
(function () {
  'use strict';
  if (window.__imx) return;
  window.__imx = true;

  var d = document;
  var html = d.documentElement;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)');
  var hasIO = 'IntersectionObserver' in window;
  var scrollTimeline = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()'));

  function reduced() { return RM.matches; }
  // Horizon 4.3 : sur ordinateur (≥ 990 px), c'est .page-wrapper qui défile, pas la fenêtre.
  var SQUEEZE = window.matchMedia('(min-width: 990px)');
  function scroller() {
    var pw = SQUEEZE.matches && d.querySelector('.page-wrapper');
    if (pw && pw.scrollHeight > pw.clientHeight + 1) return pw;
    return d.scrollingElement || html;
  }
  // Écoute en phase de capture : reçoit le défilement de la fenêtre ET celui de .page-wrapper.
  function onScroll(fn) { window.addEventListener('scroll', fn, { capture: true, passive: true }); }
  function all(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }
  function once(el, fn, threshold) {
    if (!hasIO || reduced()) { fn(); return; }
    var o = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { o.disconnect(); fn(); }
    }, { threshold: threshold || 0.3 });
    o.observe(el);
  }

  /* ---------- Dates : jours ouvrés français ---------- */
  var HOLIDAYS = ['2026-11-01', '2026-11-11', '2026-12-25', '2027-01-01', '2027-03-29', '2027-05-01', '2027-05-06', '2027-05-08', '2027-05-17', '2027-07-14', '2027-08-15', '2027-11-01', '2027-11-11', '2027-12-25'];
  function pad(n) { return String(n).padStart(2, '0'); }
  function iso(x) { return x.getFullYear() + '-' + pad(x.getMonth() + 1) + '-' + pad(x.getDate()); }
  function addBusinessDays(start, n) {
    var x = new Date(start.getTime());
    var added = 0;
    while (added < n) {
      x.setDate(x.getDate() + 1);
      var wd = x.getDay();
      if (wd !== 0 && wd !== 6 && HOLIDAYS.indexOf(iso(x)) === -1) added++;
    }
    return x;
  }
  function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  function sameOrBefore(a, b) {
    return new Date(a.getFullYear(), a.getMonth(), a.getDate()) <= new Date(b.getFullYear(), b.getMonth(), b.getDate());
  }
  function fmt(x, withMonth) {
    var opts = withMonth ? { weekday: 'long', day: 'numeric', month: 'long' } : { weekday: 'long', day: 'numeric' };
    return x.toLocaleDateString('fr-FR', opts);
  }

  function initEta(root) {
    all('[data-imx-eta]', root).forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min') || '5', 10);
      var max = parseInt(el.getAttribute('data-max') || '10', 10);
      var now = new Date();
      var a = addBusinessDays(now, min);
      var b = addBusinessDays(now, max);
      var out = el.querySelector('[data-imx-eta-text]');
      if (!out) return;
      out.innerHTML = 'Chez toi entre le <strong>' + fmt(a, a.getMonth() !== b.getMonth()) + '</strong> et le <strong>' + fmt(b, true) + '</strong>.';
      // initXmas(el, now, max); // message de Noël coupé à la demande d'Issam (19/10/2026)
    });
  }

  // Noël : date limite = délai maximum + 3 jours ouvrés de marge, pour une livraison prévue au plus tard le 23 décembre.
  function initXmas(el, now, max) {
    var box = el.querySelector('[data-imx-xmas]');
    if (!box) return;
    var y = now.getFullYear();
    if (now < new Date(y, 10, 1) || now > new Date(y, 11, 24, 23, 59)) { box.hidden = true; return; }
    var target = new Date(y, 11, 23);
    var cutoff = null;
    for (var i = 0; i < 60; i++) {
      var cand = new Date(y, 11, 23 - i);
      if (addBusinessDays(cand, max + 3) <= target) { cutoff = cand; break; }
    }
    if (!cutoff) { box.hidden = true; return; }
    if (sameOrBefore(now, cutoff)) {
      box.innerHTML = 'Pour Noël\u00a0: commande au plus tard le <strong>' + fmt(cutoff, true) + '</strong> pour une livraison prévue avant le 24 décembre.';
    } else {
      box.textContent = 'Pour Noël : une livraison avant le 24 décembre n’est plus certaine.';
    }
    box.hidden = false;
  }

  // Bandeau du haut : du 1/11 à la date limite de Noël (même règle que la fiche, délai max 10 jours ouvrés), on rappelle la vraie date.
  function initXmasBar() {
    var p = d.querySelector('.announcement-bar__text');
    if (!p) return;
    var now = new Date(), y = now.getFullYear();
    if (now < new Date(y, 10, 1)) return;
    for (var i = 0; i < 60; i++) {
      var cand = new Date(y, 11, 23 - i);
      if (addBusinessDays(cand, 13) <= new Date(y, 11, 23)) {
        if (sameOrBefore(now, cand)) p.textContent = 'Pour Noël, commande d’ici le ' + fmt(cand, true) + (window.innerWidth >= 600 ? ' · Livraison suivie offerte' : '');
        return;
      }
    }
  }

  // Date et heure du jour, façon ticket : 10/10/2026 · 14:32
  function initToday(root) {
    var now = new Date();
    var s = pad(now.getDate()) + '/' + pad(now.getMonth() + 1) + '/' + now.getFullYear() + ' · ' + pad(now.getHours()) + ':' + pad(now.getMinutes());
    all('[data-imx-today]', root).forEach(function (el) { el.textContent = s; });
  }

  /* ---------- Galerie produit ---------- */
  function goToSlide(gallery, index, smooth) {
    var track = gallery.querySelector('[data-imx-track]');
    var slide = track && track.children[index];
    if (!slide) return;
    track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: smooth && !reduced() ? 'smooth' : 'auto' });
  }

  function initGallery(gallery) {
    if (gallery.__imx) return;
    gallery.__imx = true;
    var track = gallery.querySelector('[data-imx-track]');
    if (!track) return;
    var count = track.children.length;
    var thumbs = all('[data-imx-thumb]', gallery);
    var counter = gallery.querySelector('[data-imx-count]');
    var prev = gallery.querySelector('[data-imx-prev]');
    var next = gallery.querySelector('[data-imx-next]');
    var current = 0;
    function mark(i) {
      current = i;
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      if (counter) counter.textContent = pad(i + 1) + ' / ' + pad(count);
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= count - 1;
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        mark(Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)));
      });
    }, { passive: true });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goToSlide(gallery, i, true); }); });
    if (prev) prev.addEventListener('click', function () { goToSlide(gallery, Math.max(0, current - 1), true); });
    if (next) next.addEventListener('click', function () { goToSlide(gallery, Math.min(count - 1, current + 1), true); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goToSlide(gallery, Math.min(count - 1, current + 1), true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goToSlide(gallery, Math.max(0, current - 1), true); }
    });
    mark(0);
    // Arrivée avec ?variant= : on montre directement la photo de la couleur choisie.
    var checked = d.querySelector('[data-imx-buy][data-main="true"] input[data-variant-id]:checked');
    var mid = checked && checked.getAttribute('data-media-id');
    if (mid) all('[data-media-id]', gallery).forEach(function (s, i) {
      if (i > 0 && s.getAttribute('data-media-id') === mid) requestAnimationFrame(function () { goToSlide(gallery, i, false); });
    });
  }

  // Fond coloré et référence : seulement dans la section du formulaire (galerie produit ou achat final).
  function applyLook(form, radio) {
    var scope = form.closest('.imx') || d;
    all('[data-imx-wash]', scope).forEach(function (g) { g.setAttribute('data-imx-wash', radio.getAttribute('data-wash')); });
    all('[data-imx-sku]', scope).forEach(function (s) { s.textContent = radio.getAttribute('data-sku'); });
  }

  /* ---------- Formulaires d'achat ---------- */  function initBuy(form) {
    if (form.__imx) return;
    form.__imx = true;
    var input = form.querySelector('[data-imx-variant-input]');
    var label = form.querySelector('[data-imx-label]');
    var addon = form.querySelector('[data-imx-addon]');
    var totalEl = form.querySelector('[data-imx-total]');
    var submitBtn = form.querySelector('[data-imx-submit]');
    var isMain = form.getAttribute('data-main') === 'true';

    function basePrice() {
      var r = form.querySelector('input[type="radio"][data-variant-id]:checked');
      var v = r ? r.getAttribute('data-price') : (submitBtn && submitBtn.getAttribute('data-base-price'));
      return parseInt(v || '0', 10);
    }
    function updateTotal() {
      var withAddon = !!(addon && addon.checked);
      var total = basePrice() + (withAddon ? parseInt(addon.getAttribute('data-price') || '0', 10) : 0);
      if (totalEl) totalEl.textContent = money(total);
      // Cartes « pack » : prix de chaque pack, et prix barré = somme des deux prix réels.
      if (addon) {
        var add = parseInt(addon.getAttribute('data-price') || '0', 10);
        var off = parseInt(addon.getAttribute('data-off') || '0', 10);
        all('[data-imx-pack-price="0"]', form).forEach(function (e) { e.textContent = money(basePrice()); });
        all('[data-imx-pack-price="1"]', form).forEach(function (e) { e.textContent = money(basePrice() + add); });
        all('[data-imx-pack-was]', form).forEach(function (e) { e.textContent = money(basePrice() + add + off); });
      }
      // Le paiement express ne sait payer que la variante : on le cache quand l'option est cochée.
      form.classList.toggle('has-addon', withAddon);
      if (isMain) all('[data-imx-sticky-total]').forEach(function (st) { st.textContent = money(total); });
    }
    function applyVariant(radio) {
      input.value = radio.getAttribute('data-variant-id');
      if (label) label.textContent = radio.getAttribute('data-title');
    }
    form.__imxUpdate = updateTotal;
    if (addon) addon.addEventListener('change', updateTotal);
    // Type de recharge (papier blanc, autocollant, couleur) : ne compte que si la case est cochée.
    all('[data-imx-addon-type]', form).forEach(function (t) {
      t.addEventListener('change', function () {
        if (!t.checked || !addon) return;
        addon.value = t.value;
        addon.setAttribute('data-price', t.getAttribute('data-price'));
        var lbl = form.querySelector('[data-imx-addon-price]');
        if (lbl) lbl.textContent = '+' + money(parseInt(t.getAttribute('data-price'), 10));
        var sub = form.querySelector('[data-imx-pack-sub]');
        if (sub) sub.textContent = '+ ' + t.closest('label').textContent.trim().toLowerCase();
        updateTotal();
      });
    });
    // Cartes « pack » : « Imprimante seule » (par défaut) ou « Imprimante + recharge ».
    all('[data-imx-pack]', form).forEach(function (p) {
      p.addEventListener('change', function () {
        if (!p.checked || !addon) return;
        addon.checked = p.value === '1';
        updateTotal();
      });
    });

    all('input[type="radio"][data-variant-id]', form).forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        applyVariant(radio);
        // Synchronise les autres formulaires (page produit + achat final).
        all('[data-imx-buy] input[data-variant-id="' + input.value + '"]').forEach(function (other) {
          if (other === radio) return;
          other.checked = true;
          var f = other.closest('[data-imx-buy]');
          f.querySelector('[data-imx-variant-input]').value = input.value;
          var l = f.querySelector('[data-imx-label]');
          if (l) l.textContent = radio.getAttribute('data-title');
          if (f.__imxUpdate) f.__imxUpdate();
          applyLook(f, radio);
        });
        updateTotal();
        // Fond de galerie, référence, photo de la couleur choisie.
        applyLook(form, radio);
        var mediaId = radio.getAttribute('data-media-id');
        var gallery = d.querySelector('[data-imx-gallery]');
        if (gallery && mediaId) {
          all('[data-media-id]', gallery).forEach(function (s, i) {
            if (s.getAttribute('data-media-id') === mediaId) goToSlide(gallery, i, true);
          });
        }
        if (isMain && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', input.value);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var err = form.querySelector('[data-imx-error]');
      if (submitBtn) submitBtn.setAttribute('aria-busy', 'true');
      if (err) err.hidden = true;
      var items = [{ id: parseInt(input.value, 10), quantity: 1 }];
      if (addon && addon.checked) items.push({ id: parseInt(addon.value, 10), quantity: 1 });
      var headers = { 'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
      // « Commander » = exactement ce qui est choisi : on vide d'abord le panier pour éviter les doublons.
      fetch('/cart/clear.js', { method: 'POST', headers: headers, body: '{}' }).then(function () {
        return fetch('/cart/add.js', { method: 'POST', headers: headers, body: JSON.stringify({ items: items }) });
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        window.location.href = '/checkout';
      }).catch(function () {
        if (submitBtn) submitBtn.removeAttribute('aria-busy');
        if (err) { err.textContent = 'L’ajout n’a pas marché. Réessaie dans un instant.'; err.hidden = false; }
      });
    });
    updateTotal();
  }

  /* ---------- Barre d'achat collante (mobile) ---------- */
  function initSticky() {
    var bar = d.querySelector('[data-imx-sticky]');
    var target = d.querySelector('[data-imx-buy][data-main="true"] [data-imx-submit]');
    if (!bar || !target || !hasIO || bar.__imx) return;
    bar.__imx = true;
    var footer = d.querySelector('footer');
    // Visible dès que le vrai « Commander » est hors de l'écran : au-dessus (déjà vu) ou en dessous (pas encore atteint).
    var onScreen = true, past = false, nearFooter = false;
    function update() {
      var show = !onScreen && !nearFooter;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelector('button').tabIndex = show ? 0 : -1;
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { onScreen = en.isIntersecting; past = !en.isIntersecting && en.boundingClientRect.top < 0; });
      update();
    }).observe(target);
    if (footer) new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { nearFooter = en.isIntersecting; });
      update();
    }).observe(footer);
    bar.querySelector('[data-imx-sticky-buy]').addEventListener('click', function () {
      // Choix (couleur, pack) pas encore vus : on y descend au lieu de commander à l'aveugle.
      if (!past) { (target.closest('[data-imx-buy]') || target).scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      var form = target.closest('form');
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
    update();
  }

  /* ---------- Apparition au scroll et titres en masque ---------- */
  function split(el) {
    if (el.__imxSplit || el.children.length) return;
    el.__imxSplit = true;
    // On ne coupe qu'aux espaces normales : les espaces insécables (« : », « ? ») restent collées au mot.
    var words = el.textContent.trim().split(/[ \t\r\n]+/);
    el.textContent = '';
    words.forEach(function (w, i) {
      var o = d.createElement('span');
      var inner = d.createElement('span');
      o.className = 'imx-w';
      inner.textContent = w;
      o.appendChild(inner);
      el.appendChild(o);
      if (i < words.length - 1) el.appendChild(d.createTextNode(' '));
    });
    var top = null, line = -1;
    all('.imx-w', el).forEach(function (o) {
      if (o.offsetTop !== top) { line++; top = o.offsetTop; }
      o.style.setProperty('--l', line);
    });
  }

  var revealObserver = null;
  function initReveal(root) {
    all('[data-reveal-group]', root).forEach(function (g) {
      all('[data-reveal]', g).forEach(function (el, i) {
        if (!el.style.getPropertyValue('--i')) el.style.setProperty('--i', i);
      });
    });
    if (!reduced()) all('[data-split]', root).forEach(split);
    var els = all('[data-reveal]:not(.is-in), [data-split]:not(.is-in)', root);
    if (!hasIO || reduced()) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); revealObserver.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });
    }
    var vh = window.innerHeight;
    els.forEach(function (el) {
      // Déjà visible au chargement : affiché tout de suite, sans animation (pas de clignotement).
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0 && !html.classList.contains('imx-ready')) el.classList.add('is-in');
      else revealObserver.observe(el);
    });
  }

  /* ---------- Ticket de la bannière : s'imprime tout seul dès qu'il est visible (à l'arrivée sur la page) ---------- */
  function initFeed(root) {
    all('[data-imx-feed]', root).forEach(function (el) {
      if (reduced()) { el.classList.add('is-printed'); return; }
      once(el, function () { el.classList.add('is-printing'); }, 0.2);
    });
  }

  /* ---------- Reçu : les lignes s'impriment une à une ---------- */
  function initPrint(root) {
    all('[data-imx-print]', root).forEach(function (el) {
      once(el, function () { el.classList.add('is-printed'); }, 0.25);
    });
  }

  /* ---------- Démo téléphone → ticket ---------- */
  function initDemo(root) {
    all('[data-imx-demo]', root).forEach(function (demo) {
      var out = demo.querySelector('[data-imx-type]');
      var text = out ? out.getAttribute('data-imx-type') : '';
      var timers = [];
      function finish() {
        if (out) out.textContent = text;
        demo.classList.add('is-typed', 'is-sent', 'is-printed');
      }
      function play() {
        timers.forEach(clearTimeout);
        timers = [];
        demo.classList.remove('is-typed', 'is-sent', 'is-printed');
        if (reduced() || !out) { finish(); return; }
        var i = 0;
        demo.classList.add('is-typing');
        (function tick() {
          i++;
          out.textContent = text.slice(0, i);
          if (i < text.length) { timers.push(setTimeout(tick, 65 + Math.random() * 55)); return; }
          demo.classList.remove('is-typing');
          demo.classList.add('is-typed');
          timers.push(setTimeout(function () { demo.classList.add('is-sent'); }, 900));
          timers.push(setTimeout(function () { demo.classList.add('is-printed'); }, 1700));
        })();
      }
      if (out) out.textContent = '';
      var replay = demo.querySelector('[data-imx-replay]');
      if (replay) replay.addEventListener('click', play);
      if (reduced()) { finish(); return; }
      once(demo, play, 0.45);
    });
  }

  /* ---------- « Comment ça marche » : étape active + trait de progression ---------- */
  function initSteps(root) {
    all('[data-imx-steps]', root).forEach(function (sec) {
      var steps = all('[data-imx-step]', sec);
      var visuals = all('[data-imx-step-visual]', sec);
      var line = sec.querySelector('[data-imx-steps-line]');
      var list = sec.querySelector('[data-imx-steps-list]');
      function setActive(i) {
        steps.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
        visuals.forEach(function (v, j) { v.classList.toggle('is-active', j === i); });
      }
      setActive(0);
      if (hasIO) {
        var o = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) setActive(steps.indexOf(en.target)); });
        }, { rootMargin: '-45% 0px -45% 0px' });
        steps.forEach(function (s) { o.observe(s); });
      }
      if (!line || !list) return;
      if (reduced() || !hasIO) { line.style.transform = 'none'; return; }
      var visible = false, ticking = false;
      function upd() {
        ticking = false;
        var r = list.getBoundingClientRect();
        var p = (window.innerHeight * 0.55 - r.top) / Math.max(r.height, 1);
        line.style.transform = 'scaleY(' + Math.max(0, Math.min(1, p)).toFixed(3) + ')';
      }
      new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; if (visible) upd(); }).observe(list);
      onScroll(function () {
        if (visible && !ticking) { ticking = true; requestAnimationFrame(upd); }
      });
    });
  }

  /* ---------- Inclinaison 3D de la photo produit (ordinateur) ---------- */
  function initTilt(root) {
    if (!FINE.matches || reduced()) return;
    all('[data-imx-tilt]', root).forEach(function (el) {
      if (el.__imx) return;
      el.__imx = true;
      var raf = 0, rx = 0, ry = 0;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        ry = ((e.clientX - r.left) / r.width - 0.5) * 12;   // ±6°
        rx = -((e.clientY - r.top) / r.height - 0.5) * 12;
        if (!raf) raf = requestAnimationFrame(function () {
          raf = 0;
          el.style.transform = 'perspective(900px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
        });
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- « Essaie-la » : ticket en direct et photo en version thermique ---------- */
  // Rendu « papier thermique » d'une photo, entièrement dans le navigateur (la photo n'est jamais envoyée).
  // 1. On calcule l'image à la taille réelle d'affichage (1 point = 1 pixel de l'écran), sinon la réduction efface des points.
  // 2. Réduction progressive (photo nette), contraste automatique, petite accentuation de la netteté.
  // 3. Tramage d'Atkinson en serpentin : blancs propres et noirs francs, comme les applis d'imprimante thermique.
  function dither(img, canvas) {
    var box = canvas.parentNode, cs = box && getComputedStyle(box);
    var cw = box ? box.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight) : 0;
    if (!(cw > 40)) cw = 192;
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var W = Math.max(96, Math.min(384, Math.round(cw * dpr)));
    // Photo très haute : on garde le centre plutôt que de l'écraser.
    var sw = img.naturalWidth || img.width, sh = img.naturalHeight || img.height, sy = 0;
    var maxRatio = 2.2;
    if (sh / sw > maxRatio) { sy = (sh - sw * maxRatio) / 2; sh = sw * maxRatio; }
    var H = Math.max(1, Math.round(sh * W / sw));
    // Réduction par moitiés successives : évite le crénelage d'une grande photo réduite d'un coup.
    var src = d.createElement('canvas'), sctx = src.getContext('2d'), cwid = sw, chei = sh;
    src.width = sw; src.height = sh;
    sctx.drawImage(img, 0, sy, sw, sh, 0, 0, sw, sh);
    while (cwid / 2 > W) {
      var nw = Math.round(cwid / 2), nh = Math.round(chei / 2), tmp = d.createElement('canvas');
      tmp.width = nw; tmp.height = nh;
      var tctx = tmp.getContext('2d');
      tctx.imageSmoothingQuality = 'high';
      tctx.drawImage(src, 0, 0, cwid, chei, 0, 0, nw, nh);
      src = tmp; cwid = nw; chei = nh;
    }
    canvas.width = W;
    canvas.height = H;
    canvas.style.width = (W / dpr) + 'px';
    var ctx = canvas.getContext('2d');
    ctx.imageSmoothingQuality = 'high';
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, W, H);
    ctx.drawImage(src, 0, 0, cwid, chei, 0, 0, W, H);
    var data = ctx.getImageData(0, 0, W, H), p = data.data, N = W * H, g = new Float32Array(N), i, x, y;
    for (i = 0; i < N; i++) g[i] = p[i * 4] * 0.299 + p[i * 4 + 1] * 0.587 + p[i * 4 + 2] * 0.114;
    // Contraste automatique : le 1 % le plus sombre devient noir, le 1 % le plus clair devient blanc.
    var hist = new Uint32Array(256), lo = 0, hi = 255, acc = 0;
    for (i = 0; i < N; i++) hist[g[i] | 0]++;
    for (acc = 0, lo = 0; lo < 255 && acc + hist[lo] < N * 0.01; lo++) acc += hist[lo];
    for (acc = 0, hi = 255; hi > 0 && acc + hist[hi] < N * 0.01; hi--) acc += hist[hi];
    if (hi - lo < 32) { lo = Math.max(0, lo - 16); hi = Math.min(255, hi + 16); }
    for (i = 0; i < N; i++) g[i] = Math.max(0, Math.min(255, (g[i] - lo) * 255 / (hi - lo)));
    // Netteté : on renforce l'écart entre chaque point et la moyenne de ses voisins.
    var s = new Float32Array(g);
    for (y = 1; y < H - 1; y++) {
      for (x = 1; x < W - 1; x++) {
        var k0 = y * W + x;
        var blur = (g[k0 - W - 1] + g[k0 - W] + g[k0 - W + 1] + g[k0 - 1] + g[k0] + g[k0 + 1] + g[k0 + W - 1] + g[k0 + W] + g[k0 + W + 1]) / 9;
        s[k0] = g[k0] + (g[k0] - blur) * 0.6;
      }
    }
    g = s;
    // Tramage d'Atkinson (1/8 de l'erreur vers 6 voisins), une ligne sur deux de droite à gauche.
    for (y = 0; y < H; y++) {
      var rtl = y % 2 === 1, step = rtl ? -1 : 1;
      for (var c = 0; c < W; c++) {
        x = rtl ? W - 1 - c : c;
        var k = y * W + x, o = g[k], n = o < 128 ? 0 : 255, e = (o - n) / 8;
        g[k] = n;
        var x1 = x + step, x2 = x + 2 * step, xb = x - step;
        if (x1 >= 0 && x1 < W) g[k + step] += e;
        if (x2 >= 0 && x2 < W) g[k + 2 * step] += e;
        if (y + 1 < H) {
          if (xb >= 0 && xb < W) g[k + W - step] += e;
          g[k + W] += e;
          if (x1 >= 0 && x1 < W) g[k + W + step] += e;
        }
        if (y + 2 < H) g[k + 2 * W] += e;
      }
    }
    // Points noirs = chauffe de la tête thermique ; le reste devient transparent pour laisser voir la couleur du papier.
    for (i = 0; i < N; i++) {
      p[i * 4] = 21; p[i * 4 + 1] = 24; p[i * 4 + 2] = 29; p[i * 4 + 3] = g[i] < 128 ? 255 : 0;
    }
    ctx.putImageData(data, 0, 0);
  }

  function initTry(root) {
    all('[data-imx-try]', root).forEach(function (sec) {
      if (sec.__imx) return;
      sec.__imx = true;
      var input = sec.querySelector('[data-imx-try-input]');
      var out = sec.querySelector('[data-imx-try-out]');
      var count = sec.querySelector('[data-imx-try-count]');
      var strip = sec.querySelector('[data-imx-try-strip]');
      var canvas = sec.querySelector('[data-imx-try-canvas]');
      var feed = sec.querySelector('[data-imx-try-feed]');
      var file = sec.querySelector('[data-imx-try-file]');
      var tabs = all('[data-imx-try-tab]', sec);
      var panes = all('[data-imx-try-pane]', sec);
      var hasPhoto = false;
      function sync() {
        out.textContent = input.value || ' ';
        if (count) count.textContent = input.value.length;
      }
      function print() {
        if (reduced()) return;
        feed.classList.remove('is-printing');
        void feed.offsetWidth;
        feed.classList.add('is-printing');
      }
      function setMode(m) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-imx-try-tab') === m;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        panes.forEach(function (pane) { pane.hidden = pane.getAttribute('data-imx-try-pane') !== m; });
        out.hidden = m === 'photo' && hasPhoto;
        canvas.hidden = !(m === 'photo' && hasPhoto);
      }
      input.addEventListener('input', sync);
      all('[data-imx-try-tpl]', sec).forEach(function (b) {
        b.addEventListener('click', function () {
          input.value = b.getAttribute('data-imx-try-tpl');
          sync();
          setMode('text');
          print();
        });
      });
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { setMode(t.getAttribute('data-imx-try-tab')); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          n.focus();
          n.click();
        });
      });
      all('[data-imx-try-paper]', sec).forEach(function (r) {
        r.addEventListener('change', function () { strip.setAttribute('data-paper', r.value); print(); });
      });
      sec.querySelector('[data-imx-try-print]').addEventListener('click', print);
      if (file) file.addEventListener('change', function () {
        var f = file.files && file.files[0];
        if (!f) return;
        var url = URL.createObjectURL(f);
        var img = new Image();
        img.onload = function () {
          lastImg = img;
          dither(img, canvas);
          URL.revokeObjectURL(url);
          hasPhoto = true;
          setMode('photo');
          print();
        };
        img.src = url;
      });
      // Si la largeur du ticket change (rotation du téléphone, fenêtre redimensionnée), on recalcule l'image point par point.
      var lastImg = null, rz = 0, lastW = 0;
      window.addEventListener('resize', function () {
        if (!lastImg) return;
        clearTimeout(rz);
        rz = setTimeout(function () {
          var w = canvas.parentNode ? canvas.parentNode.clientWidth : 0;
          if (w && w !== lastW) { lastW = w; dither(lastImg, canvas); }
        }, 200);
      });
      sync();
    });
  }

  /* ---------- Onglets « Tout savoir » (clavier, ancres #mode-d-emploi, #questions…) ---------- */
  function initTabs(root) {
    all('[data-imx-tabs]', root).forEach(function (sec) {
      if (sec.__imxTabs) return;
      sec.__imxTabs = true;
      var tabs = all('[role="tab"]', sec);
      var panels = tabs.map(function (t) { return d.getElementById(t.getAttribute('aria-controls')); });
      if (!tabs.length) return;
      function select(i, focus) {
        tabs.forEach(function (t, j) {
          var on = j === i;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (panels[j]) {
            panels[j].classList.toggle('is-active', on);
            panels[j].hidden = !on;
          }
        });
        if (focus) tabs[i].focus({ preventScroll: true });
        // Sur mobile la barre d'onglets défile à l'horizontale : on garde l'onglet choisi visible.
        var nav = tabs[i].parentNode;
        if (nav && nav.scrollWidth > nav.clientWidth + 2) {
          var x = tabs[i].offsetLeft - (nav.clientWidth - tabs[i].offsetWidth) / 2;
          nav.scrollTo({ left: Math.max(0, x), behavior: reduced() ? 'auto' : 'smooth' });
        }
      }
      // Fondu sur le bord quand des onglets sont cachés à droite ou à gauche.
      var navEl = tabs[0].parentNode;
      function edges() {
        var over = navEl.scrollWidth > navEl.clientWidth + 2;
        navEl.classList.toggle('is-more-right', over && navEl.scrollLeft + navEl.clientWidth < navEl.scrollWidth - 2);
        navEl.classList.toggle('is-more-left', over && navEl.scrollLeft > 2);
      }
      navEl.addEventListener('scroll', edges, { passive: true });
      window.addEventListener('resize', edges);
      edges();
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, n = null;
          if (k === 'ArrowRight' || k === 'ArrowDown') n = (i + 1) % tabs.length;
          if (k === 'ArrowLeft' || k === 'ArrowUp') n = (i + tabs.length - 1) % tabs.length;
          if (k === 'Home') n = 0;
          if (k === 'End') n = tabs.length - 1;
          if (n === null) return;
          e.preventDefault();
          select(n, true);
        });
      });
      // Un lien vers #questions (ou un autre onglet) ouvre le bon onglet puis fait défiler jusqu'à la section.
      function openFromHash(hash, scroll) {
        var id = (hash || '').replace('#', '');
        if (!id) return false;
        var i = -1;
        panels.forEach(function (pnl, j) { if (pnl && pnl.id === id) i = j; });
        if (i < 0 && id !== sec.id) return false;
        if (i >= 0) select(i);
        if (scroll) sec.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
        return true;
      }
      d.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('a[href^="#"]');
        if (!a) return;
        if (openFromHash(a.getAttribute('href'), true)) {
          e.preventDefault();
          if (window.history && history.replaceState) history.replaceState(history.state, '', a.getAttribute('href'));
        }
      });
      window.addEventListener('hashchange', function () { openFromHash(location.hash, true); });
      var start = 0;
      tabs.forEach(function (t, j) { if (t.getAttribute('aria-selected') === 'true') start = j; });
      select(start);
      if (location.hash) openFromHash(location.hash, true);
    });
  }

  /* ---------- Navigation produit (ordinateur) et barre d'achat (mobile, accueil) ---------- */  function initLocalnav() {
    var nav = d.querySelector('[data-imx-localnav]');
    var bar = d.querySelector('[data-imx-homebar]');
    if ((!nav && !bar) || !hasIO) return;
    var start = d.querySelector('[data-imx-hero]') || d.querySelector('[data-imx-buy][data-main="true"]');
    var end = d.querySelector('#commander') || d.querySelector('footer');
    var past = false, atEnd = false;
    function upd() {
      if (nav) nav.classList.toggle('is-visible', past);
      if (bar) {
        var show = past && !atEnd;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        bar.querySelector('a').tabIndex = show ? 0 : -1;
      }
    }
    if (start) new IntersectionObserver(function (en) {
      past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      upd();
    }).observe(start);
    if (end) new IntersectionObserver(function (en) {
      atEnd = en[0].isIntersecting || en[0].boundingClientRect.top < 0;
      upd();
    }, { rootMargin: '0px 0px -30% 0px' }).observe(end);
    // Lien de la section en cours mis en évidence.
    if (!nav) return;
    // Suivi calculé à chaque défilement (fiable même en défilant vite) : le lien actif est celui de la
    // dernière section dont le haut a passé la ligne des 40 % de l'écran. Un onglet (ex. #questions)
    // compte pour la section qui le contient, puisque les onglets cachés n'ont pas de position.
    var links = all('[data-imx-spy]', nav);
    var items = [];
    links.forEach(function (a) {
      var t = d.querySelector(a.getAttribute('href'));
      if (!t) return;
      var sec = t.closest('.shopify-section') || t;
      items.push({ a: a, el: sec, tab: t.getAttribute('role') === 'tabpanel' ? t : null });
    });
    var current = null, ticking = false;
    function spy() {
      ticking = false;
      var line = window.innerHeight * 0.4, best = null;
      items.forEach(function (it) {
        var r = it.el.getBoundingClientRect();
        if (r.top > line || r.bottom <= 0) return;
        // Plusieurs liens dans la même section (onglets) : on garde l'onglet affiché.
        if (it.tab && !it.tab.classList.contains('is-active')) return;
        if (!best || r.top >= best.top) best = { a: it.a, top: r.top };
      });
      var a = best ? best.a : null;
      if (a === current) return;
      current = a;
      links.forEach(function (l) { l.removeAttribute('aria-current'); });
      if (a) a.setAttribute('aria-current', 'true');
    }
    onScroll(function () { if (!ticking) { ticking = true; requestAnimationFrame(spy); } });
    d.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[role="tab"]')) requestAnimationFrame(spy); });
    spy();
  }

  /* ---------- Barre de progression de lecture ---------- */
  function initProgress() {
    var bar = d.querySelector('[data-imx-progress]');
    if (!bar) return;
    var ticking = false;
    function upd() {
      ticking = false;
      var s = scroller();
      var max = Math.max(1, s.scrollHeight - s.clientHeight);
      bar.style.transform = 'scaleX(' + Math.min(1, s.scrollTop / max).toFixed(4) + ')';
    }
    function ask() { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }
    onScroll(ask);
    window.addEventListener('resize', ask, { passive: true });
    window.addEventListener('load', ask);
    upd();
  }

  /* ---------- Démarrage ---------- */
  // Chaque module est isolé : si l'un plante, les autres continuent et le contenu reste visible.
  function safe(fn, arg) {
    try { fn(arg); return true; } catch (e) { if (window.console) console.error('[imx]', e); return false; }
  }
  function initAll(root) {
    safe(initEta, root);
    safe(initToday, root);
    all('[data-imx-gallery]', root).forEach(function (g) { safe(initGallery, g); });
    all('[data-imx-buy]', root).forEach(function (f) { safe(initBuy, f); });
    var revealOk = safe(initReveal, root);
    safe(initFeed, root);
    safe(initPrint, root);
    safe(initDemo, root);
    safe(initSteps, root);
    safe(initTilt, root);
    safe(initTry, root);
    safe(initTabs, root);
    safe(initHeroColors, root);
    safe(initFaqSearch, root);
    safe(initTrack, root);
    safe(initContact, root);
    safe(initReviews, root);
    safe(initReviewBands, root);
    safe(initAvisPage, root);
    safe(countUp, root);
    safe(initPerf, root);
    safe(initHeroPrinter, root);
    return revealOk;
  }

  /* ---------- Contact : le ticket s'imprime en direct avec ce que le client écrit ---------- */
  function initContact(root) {
    all('[data-imx-contactp]', root).forEach(function (pg) {
      if (pg.__imx) return;
      pg.__imx = true;
      var form = pg.querySelector('[data-imx-contact-form]');
      if (!form) return;
      var name = form.querySelector('[data-imx-contact-name]');
      var body = form.querySelector('[data-imx-contact-body]');
      var order = form.querySelector('[data-imx-contact-ordernum]');
      var count = form.querySelector('[data-imx-contact-count]');
      var ticket = pg.querySelector('[data-imx-contact-ticket]');
      var tName = pg.querySelector('[data-imx-contact-t-name]');
      var tTopic = pg.querySelector('[data-imx-contact-t-topic]');
      var tMsg = pg.querySelector('[data-imx-contact-t-msg]');
      var tOrder = pg.querySelector('[data-imx-contact-t-order]');
      var tOrderRow = pg.querySelector('[data-imx-contact-t-orderrow]');
      var empty = tMsg ? tMsg.textContent : '';
      var bump = 0;
      function feed() {
        if (!ticket || reduced()) return;
        clearTimeout(bump);
        ticket.classList.add('is-feeding');
        bump = setTimeout(function () { ticket.classList.remove('is-feeding'); }, 260);
      }
      function sync() {
        var topic = form.querySelector('[data-imx-contact-topic]:checked');
        if (tTopic && topic) tTopic.textContent = topic.value;
        if (tName) tName.textContent = (name && name.value.trim()) || 'Toi';
        var msg = body ? body.value : '';
        if (tMsg) tMsg.textContent = msg.trim() ? msg : empty;
        if (count) count.textContent = msg.length;
        var o = order ? order.value.trim() : '';
        if (tOrder) tOrder.textContent = o;
        if (tOrderRow) tOrderRow.hidden = !o;
        // Le champ « N° de commande » n'est mis en avant que pour les sujets liés à une commande.
        var needOrder = topic && /commande|retour|garantie/i.test(topic.value);
        var box = form.querySelector('[data-imx-contact-order]');
        if (box) box.classList.toggle('is-muted', !needOrder);
      }
      form.addEventListener('input', function () { sync(); feed(); });
      form.addEventListener('change', sync);
      form.addEventListener('submit', function () {
        var btn = form.querySelector('[data-imx-contact-send]');
        if (btn && form.checkValidity()) { btn.setAttribute('aria-busy', 'true'); if (ticket) ticket.classList.add('is-sent'); }
      });
      sync();
    });
  }

  /* ---------- Avis : filtres par usage ---------- */
  function initReviews(root) {
    all('[data-imx-revp]', root).forEach(function (pg) {
      if (pg.__imx) return;
      pg.__imx = true;
      var btns = all('[data-imx-rev-filter]', pg);
      var cards = all('[data-imx-rev-tag]', pg);
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var f = b.getAttribute('data-imx-rev-filter');
          btns.forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          cards.forEach(function (c) { c.hidden = !!f && c.getAttribute('data-imx-rev-tag') !== f; if (!c.hidden) c.classList.add('is-in'); });
        });
      });
    });
  }

  /* ---------- Avis Judge.me (importés d'AliExpress) : chargement en direct, bande, page, note animée ---------- */
  // Les noms de l'import sont inventés par l'outil : on affiche « Client du fabricant », sans date.
  var revCache = {};
  function loadReviews(shop, pid, cb) {
    var k = shop + pid;
    if (revCache[k]) return revCache[k].then(cb);
    try { var s = sessionStorage.getItem('imx-rv-' + k); if (s) { revCache[k] = Promise.resolve(JSON.parse(s)); return revCache[k].then(cb); } } catch (e) {}
    if (!window.fetch) return;
    revCache[k] = fetch('https://judge.me/reviews/reviews_for_widget?url=' + shop + '&shop_domain=' + shop + '&platform=shopify&page=1&per_page=60&product_id=' + pid)
      .then(function (r) { return r.json(); })
      .then(function (d) { try { sessionStorage.setItem('imx-rv-' + k, JSON.stringify(d)); } catch (e) {} return d; });
    revCache[k].then(cb).catch(function () {});
  }
  function revText(r) { var t = d.createElement('div'); t.innerHTML = r.body_html || r.body || ''; return t.textContent.replace(/\s+/g, ' ').trim(); }
  // Avis à ne pas montrer : délai de livraison chiffré ou « livraison rapide » (c'était le délai du fabricant, pas le nôtre : 5 à 10 jours ouvrés),
  // et doublons exacts laissés par l'import.
  var DELAY = /\d+\s*(?:-|à|a|ou)?\s*\d*\s*jours|livraison\s+(?:très\s+|super\s+|assez\s+)?rapide|(?:arriv|reçu|livr)\S*\s+(?:très\s+|super\s+)?(?:vite|rapidement)/i;
  function showable(list) {
    var seen = {};
    return list.filter(function (r) { var t = revText(r); if (DELAY.test(t) || seen[t]) return false; seen[t] = 1; return true; });
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function revCard(r, mini) {
    var txt = revText(r), pics = r.pictures_urls || [];
    if (mini && txt.length > 150) txt = txt.slice(0, 147).replace(/\s+\S*$/, '') + '…';
    var h = '<span class="imx-revp__stars" style="--r: ' + (+r.rating || 5) + '"></span>';
    if (mini) return '<figure class="imx-rv imx-rv--mini">' + h + (pics[0] ? '<img referrerpolicy="no-referrer" crossorigin="anonymous" data-imx-chk class="imx-rv__thumb" src="' + esc(pics[0].compact || pics[0].original) + '" alt="" loading="lazy" width="56" height="56">' : '') + '<blockquote>' + esc(txt) + '</blockquote><figcaption>Client du fabricant</figcaption></figure>';
    var ph = pics.slice(0, 4).map(function (p) { return '<button type="button" class="imx-rv__pic" data-imx-avis-zoom="' + esc(p.huge || p.original) + '"><img referrerpolicy="no-referrer" crossorigin="anonymous" data-imx-chk src="' + esc(p.compact || p.original) + '" alt="Photo d\'un client du fabricant" loading="lazy" width="120" height="120"></button>'; }).join('');
    return '<article class="imx-rv is-in" data-rating="' + (+r.rating) + '" data-photos="' + pics.length + '"><header>' + h + '</header><p>' + esc(txt) + '</p>' + (ph ? '<div class="imx-rv__pics">' + ph + '</div>' : '') + '<footer><span class="imx-rv__av"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>Client du fabricant</footer></article>';
  }
  // Retire les photos d'avis presque noires (photos ratées) : moyenne de luminosité sur 8 × 8 points.
  // Une même photo revient plusieurs fois (bandes qui défilent) : on ne la mesure qu'une fois, quand le navigateur est libre.
  var darkCache = {};
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 200); };
  function checkDark(root) {
    all('img[data-imx-chk]', root).forEach(function (img) {
      function drop() { (img.closest('.imx-rv__pic') || img).remove(); }
      function test() {
        var src = img.currentSrc || img.src;
        if (src in darkCache) { if (darkCache[src]) drop(); return; }
        idle(function () {
          if (!(src in darkCache)) {
            try {
              var cv = d.createElement('canvas'); cv.width = cv.height = 8;
              var cx = cv.getContext('2d'); cx.drawImage(img, 0, 0, 8, 8);
              var px = cx.getImageData(0, 0, 8, 8).data, s = 0;
              for (var i = 0; i < px.length; i += 4) s += px[i] + px[i + 1] + px[i + 2];
              darkCache[src] = s / 192 < 28;
            } catch (e) { darkCache[src] = false; }
          }
          if (darkCache[src]) drop();
        });
      }
      if (img.complete && img.naturalWidth) test(); else img.addEventListener('load', test, { once: true });
      img.addEventListener('error', function () { (img.closest('.imx-rv__pic') || img).remove(); }, { once: true });
    });
  }
  function initReviewBands(root) {
    all('[data-imx-revband]', root).forEach(function (band) {
      if (band.__imx) return;
      band.__imx = true;
      loadReviews(band.getAttribute('data-shop'), band.getAttribute('data-pid'), function (dt) {
        var list = showable((dt.reviews || []).filter(function (r) { return revText(r).length > 15; }));
        var kw = band.getAttribute('data-keywords');
        if (kw) { var re = new RegExp(kw, 'i'); list.sort(function (a, b) { return (re.test(revText(b)) ? 1 : 0) - (re.test(revText(a)) ? 1 : 0); }); }
        if (list.length < 4) return;
        var rows = [list.filter(function (x, i) { return i % 2 === 0; }), list.filter(function (x, i) { return i % 2 === 1; })];
        all('[data-imx-revband-track]', band).forEach(function (tr, i) {
          var html = rows[i].map(function (r) { return revCard(r, true); }).join('');
          tr.innerHTML = html + (window.matchMedia('(min-width: 750px)').matches ? html : '');
          checkDark(tr);
        });
      });
    });
  }
  function countUp(root) {
    all('[data-imx-countup]', root).forEach(function (el) {
      if (el.__imx || reduced()) return;
      el.__imx = true;
      var end = parseFloat(el.getAttribute('data-imx-countup')) || 0;
      once(el, function () {
        var t0 = performance.now();
        (function step(t) {
          var k = Math.min(1, (t - t0) / 1100), v = end * (1 - Math.pow(1 - k, 3));
          el.textContent = v.toFixed(1).replace('.', ',');
          if (k < 1) requestAnimationFrame(step);
        })(t0);
      }, 0.5);
    });
  }
  function initAvisPage(root) {
    all('[data-imx-avis]', root).forEach(function (pg) {
      if (pg.__imx) return;
      pg.__imx = true;
      var grid = pg.querySelector('[data-imx-avis-grid]');
      var more = pg.querySelector('[data-imx-avis-more]');
      var box = pg.querySelector('[data-imx-avis-lightbox]');
      var all_ = [], filt = '', shown = 12;
      function render() {
        var list = all_.filter(function (r) { var n = (r.pictures_urls || []).length; return !filt || (filt === 'photos' ? n > 0 : +r.rating === 5); });
        grid.innerHTML = list.slice(0, shown).map(function (r) { return revCard(r, false); }).join('');
        checkDark(grid);
        if (more) more.hidden = list.length <= shown;
      }
      loadReviews(pg.getAttribute('data-shop'), pg.getAttribute('data-pid'), function (dt) {
        all_ = showable((dt.reviews || []).filter(function (r) { return revText(r).length > 3 || (r.pictures_urls || []).length; }));
        if (all_.length) render();
      });
      if (more) more.addEventListener('click', function () { shown += 12; render(); });
      all('[data-imx-avis-filter]', pg).forEach(function (b) {
        b.addEventListener('click', function () {
          filt = b.getAttribute('data-imx-avis-filter'); shown = 12;
          all('[data-imx-avis-filter]', pg).forEach(function (x) { x.classList.toggle('is-on', x === b); });
          if (all_.length) render();
        });
      });
      pg.addEventListener('click', function (e) {
        var z = e.target.closest && e.target.closest('[data-imx-avis-zoom]');
        if (z && box && box.showModal) { box.querySelector('img').src = z.getAttribute('data-imx-avis-zoom'); box.showModal(); return; }
        if (box && (e.target === box || (e.target.closest && e.target.closest('dialog button')))) box.close();
      });
    });
  }

  /* ---------- Fluidité : pause des animations hors écran + décodage anticipé des images ---------- */
  function initPerf(root) {
    if (!hasIO) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { e.target.classList.toggle('is-offscreen', !e.isIntersecting); });
    }, { rootMargin: '100px 0px' });
    all('.imx-marquee, .imx-track__visual, .imx-faqp__visual', root).forEach(function (el) { if (!el.__imxPerf) { el.__imxPerf = true; io.observe(el); } });
    // Les images « lazy » sont décodées un écran avant d'arriver, pour ne pas saccader le défilement.
    var pre = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        pre.unobserve(e.target);
        var img = e.target;
        if (img.decode && !img.complete) { img.loading = 'eager'; img.decode().catch(function () {}); }
      });
    }, { root: (function () { var s = scroller(); return (s === d.scrollingElement || s === html) ? null : s; })(), rootMargin: '1200px 0px' });
    all('img[loading="lazy"]', root).forEach(function (img) { pre.observe(img); });
  }

  /* ---------- Suivi de commande : numéro → site de suivi ; date de commande → étape probable du jour ---------- */
  function initTrack(root) {
    all('[data-imx-track]', root).forEach(function (pg) {
      if (pg.__imx) return;
      pg.__imx = true;
      var form = pg.querySelector('[data-imx-track-form]');
      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        var n = (form.querySelector('[data-imx-track-num]').value || '').replace(/\s+/g, '');
        if (n) window.open(form.getAttribute('data-tracker') + encodeURIComponent(n), '_blank', 'noopener');
      });
      var date = pg.querySelector('[data-imx-track-date]');
      var line = pg.querySelector('[data-imx-track-line]');
      var status = pg.querySelector('[data-imx-track-status]');
      if (!date || !line) return;
      var steps = all('li', line);
      var today = new Date(); today.setHours(12, 0, 0, 0);
      date.max = iso(today);
      function bizBetween(a, b) {
        var n = 0, x = new Date(a.getTime());
        while (x < b) { x.setDate(x.getDate() + 1); var wd = x.getDay(); if (wd !== 0 && wd !== 6 && HOLIDAYS.indexOf(iso(x)) === -1 && x <= b) n++; }
        return n;
      }
      function update() {
        if (!date.value) return;
        var p = date.value.split('-'), d0 = new Date(+p[0], +p[1] - 1, +p[2], 12);
        var days = bizBetween(d0, today);
        var whens = [d0, addBusinessDays(d0, 1), addBusinessDays(d0, 3), addBusinessDays(d0, 4), addBusinessDays(d0, 5)];
        var reached = 0;
        steps.forEach(function (li, i) {
          var on = days >= parseInt(li.getAttribute('data-day'), 10);
          if (on) reached = i;
          li.classList.toggle('is-done', on);
          var w = li.querySelector('[data-imx-track-when]');
          if (w) w.textContent = i === 4 ? 'du ' + fmt(addBusinessDays(d0, 5), true) + ' au ' + fmt(addBusinessDays(d0, 10), true) : 'vers le ' + fmt(whens[i], true);
        });
        line.style.setProperty('--p', (reached / (steps.length - 1)).toFixed(3));
        var late = days > 10;
        status.classList.toggle('is-late', late);
        status.innerHTML = late
          ? 'Ça fait plus de 10 jours ouvrés&nbsp;: <a href="/pages/contact">écris-nous</a> avec ton numéro de commande, on vérifie avec le transporteur.'
          : 'Ta commande a <strong>' + days + ' jour' + (days > 1 ? 's' : '') + ' ouvré' + (days > 1 ? 's' : '') + '</strong>. Livraison prévue entre le <strong>' + fmt(addBusinessDays(d0, 5), true) + '</strong> et le <strong>' + fmt(addBusinessDays(d0, 10), true) + '</strong>.';
      }
      date.addEventListener('change', update);
      // Par défaut : une commande passée il y a 3 jours ouvrés, pour montrer la frise en action.
      var demo = new Date(today.getTime()); var k = 0;
      while (k < 3) { demo.setDate(demo.getDate() - 1); if (demo.getDay() !== 0 && demo.getDay() !== 6) k++; }
      date.value = iso(demo);
      update();
    });
  }

  /* ---------- FAQ : recherche instantanée (filtre les questions, surligne le mot, ouvre les réponses) ---------- */
  function initFaqSearch(root) {
    all('[data-imx-faqp]', root).forEach(function (pg) {
      if (pg.__imx) return;
      pg.__imx = true;
      var input = pg.querySelector('[data-imx-faqp-search]');
      var empty = pg.querySelector('[data-imx-faqp-empty]');
      var groups = all('[data-imx-faqp-group]', pg);
      if (!input) return;
      var items = [];
      groups.forEach(function (g) {
        all('details', g).forEach(function (dt) {
          var s = dt.querySelector('summary');
          items.push({ g: g, dt: dt, s: s, html: s.innerHTML, text: dt.textContent.toLowerCase() });
        });
      });
      function norm(x) { return x.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
      items.forEach(function (it) { it.n = norm(it.text); });
      function esc(x) { return x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
      var t = 0;
      input.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var q = norm(input.value.trim());
          var shown = 0;
          items.forEach(function (it) {
            var ok = !q || it.n.indexOf(q) > -1;
            it.dt.hidden = !ok;
            it.s.innerHTML = it.html;
            if (ok) shown++;
            if (q && ok) {
              it.dt.open = q.length > 2;
              var raw = input.value.trim();
              if (raw.length > 1) it.s.innerHTML = it.html.replace(new RegExp('(' + esc(raw) + ')', 'ig'), '<mark>$1</mark>');
            } else if (!q) it.dt.open = false;
          });
          groups.forEach(function (g) { g.hidden = !all('details', g).some(function (dt) { return !dt.hidden; }); });
          if (empty) empty.hidden = shown > 0;
        }, 120);
      });
    });
  }

  /* ---------- Bannière : choix de la couleur (photo, fond, ticket réimprimé, lien du bouton) ---------- */
  function initHeroColors(root) {
    all('[data-imx-hero]', root).forEach(function (hero) {
      if (hero.__imxColors) return;
      hero.__imxColors = true;
      var radios = all('[data-imx-hero-color]', hero);
      if (!radios.length) return;
      var stage = hero.querySelector('.imx-hero__stage');
      var name = hero.querySelector('[data-imx-hero-name]');
      var ticket = hero.querySelector('[data-imx-hero-ticket]');
      var cta = hero.querySelector('[data-imx-hero-cta]');
      var feed = hero.querySelector('[data-imx-feed]');
      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          if (!r.checked) return;
          var title = r.getAttribute('data-title');
          if (stage) stage.setAttribute('data-imx-wash', r.getAttribute('data-wash'));
          all('[data-imx-hero-shot]', hero).forEach(function (s) {
            var on = s.getAttribute('data-imx-hero-shot') === r.value;
            s.classList.toggle('is-active', on);
            var im = s.querySelector('img');
            if (im) im.classList.toggle('is-active', on);
          });
          if (name) name.textContent = title;
          if (cta && r.getAttribute('data-url')) cta.setAttribute('href', r.getAttribute('data-url'));
          if (ticket) ticket.textContent = title;
          // Le ticket se réimprime avec la nouvelle couleur.
          if (feed && !reduced()) {
            feed.classList.remove('is-printing', 'is-printed');
            void feed.offsetWidth;
            feed.classList.add('is-printing');
          }
        });
      });
    });
  }

  /* ---------- Bannière : imprimante interactive ----------
     Clic ou toucher = nouvelle impression (liste, merci, étiquette, chat). Impression automatique toutes les 5 s
     tant que personne n'y a touché. Elle s'incline en suivant la souris, ou le doigt sur mobile. */
  function initHeroPrinter(root) {
    all('[data-imx-hero-printer]', root).forEach(function (fig) {
      if (fig.__imxPrinter) return;
      fig.__imxPrinter = true;
      var frame = fig.querySelector('.imx-hero__frame');
      var prints = all('.imx-print', fig);
      var tap = fig.querySelector('[data-imx-hero-tap]');
      var hint = fig.parentNode.querySelector('[data-imx-hero-hint]');
      var i = 0, busy = false, touched = false, hover = false, visible = false, lastTap = 0;
      function next(manual) {
        if (prints.length < 2) return;
        // Un clic passe toujours (même pendant une impression automatique), mais pas deux clics trop rapprochés.
        if (manual) { if (Date.now() - lastTap < 400) return; lastTap = Date.now(); }
        else if (busy) return;
        busy = true;
        if (manual) { touched = true; if (hint) hint.classList.add('is-hidden'); }
        var old = prints[i];
        old.classList.remove('is-active', 'is-printing');
        i = (i + 1) % prints.length;
        var pr = prints[i];
        if (reduced()) { pr.classList.add('is-active'); busy = false; return; }
        // L'ancien ticket tombe (arraché), le nouveau sort de la fente ligne par ligne.
        old.classList.add('is-leaving');
        setTimeout(function () { old.classList.remove('is-leaving'); }, 500);
        pr.classList.remove('is-printing');
        void pr.offsetWidth;
        pr.classList.add('is-active', 'is-printing');
        frame.classList.remove('is-busy');
        void frame.offsetWidth;
        frame.classList.add('is-busy');
        setTimeout(function () { busy = false; }, 1500);
      }
      // Première impression : le ticket sort de la fente dès que la bannière est visible (après l'écran d'accueil).
      var firstDone = false;
      function firstPrint() {
        if (firstDone || reduced() || !prints.length) return;
        if (html.classList.contains('imx-intro') && !html.classList.contains('imx-intro-out')) { setTimeout(firstPrint, 200); return; }
        firstDone = true;
        prints[0].classList.remove('is-printing');
        void prints[0].offsetWidth;
        prints[0].classList.add('is-printing');
        frame.classList.add('is-busy');
      }
      if (tap) tap.addEventListener('click', function () { next(true); });
      if (hasIO) {
        // Une seule impression automatique : le ticket sort de la fente à l'arrivée, ensuite c'est le visiteur qui imprime.
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) firstPrint(); }, { threshold: 0.5 }).observe(fig);
      }
      // Inclinaison seulement à la souris : au doigt, elle se déclenchait pendant le défilement et faisait saccader.
      if (reduced() || !FINE.matches) return;
      var raf = 0, rx = 0, ry = 0;
      function tilt(e) {
        var r = fig.getBoundingClientRect();
        ry = ((e.clientX - r.left) / r.width - 0.5) * 14;    // ±7°
        rx = -((e.clientY - r.top) / r.height - 0.5) * 14;
        if (!raf) raf = requestAnimationFrame(function () {
          raf = 0;
          fig.style.transform = 'perspective(900px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) scale(1.02)';
        });
      }
      function reset() { hover = false; fig.style.transform = ''; }
      fig.addEventListener('pointerenter', function () { hover = true; });
      fig.addEventListener('pointermove', tilt);
      fig.addEventListener('pointerdown', function (e) { hover = true; if (e.pointerType !== 'mouse') tilt(e); });
      fig.addEventListener('pointerleave', reset);
      fig.addEventListener('pointercancel', reset);
      fig.addEventListener('pointerup', function (e) { if (e.pointerType !== 'mouse') setTimeout(reset, 300); });
    });
  }

  /* ---------- Écran d'accueil (logo au centre) : visible 0,9 s, puis part dès que la page est lisible ---------- */
  function initIntro() {
    var el = d.querySelector('[data-imx-loader]');
    if (!el || !html.classList.contains('imx-intro')) return;
    try { sessionStorage.setItem('imx-intro', '1'); } catch (e) {}
    var gone = false;
    // __imxIntro = moment de la 1re image affichée (l'animation du logo démarre à ce moment-là).
    function since() { return window.__imxIntro ? performance.now() - window.__imxIntro : 0; }
    function leave() {
      if (gone) return;
      gone = true;
      var wait = Math.max(0, 900 - since());
      setTimeout(function () {
        el.classList.add('is-done');
        html.classList.add('imx-intro-out');
        setTimeout(function () { html.classList.remove('imx-intro', 'imx-intro-out'); }, 850);
      }, wait);
    }
    // Le script tourne quand le HTML est prêt : on part dès que l'animation minimale est jouée, sans attendre toutes les images.
    leave();
  }

  // « Gérer les cookies » (pied de page) : rouvre les préférences de la bannière Shopify. Caché si la bannière n'est pas chargée.
  function initCookies() {
    var b = d.querySelector('[data-imx-cookies]');
    if (!b) return;
    var tries = 0;
    (function check() {
      if (window.privacyBanner && window.privacyBanner.showPreferences) {
        b.hidden = false;
        b.addEventListener('click', function () { window.privacyBanner.showPreferences(); });
      } else if (++tries < 10) setTimeout(check, 1000); // la bannière Shopify se charge après la page
    })();
  }

  function boot() {
    safe(initCookies);
    // safe(initXmasBar); // bandeau de Noël coupé à la demande d'Issam (19/10/2026)
    safe(initIntro);
    var ok = initAll(d);
    safe(initSticky);
    safe(initLocalnav);
    safe(initProgress);
    // Les états « caché avant apparition » ne s'activent que si l'apparition au scroll marche.
    if (ok) html.classList.add('imx-ready');
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();

  // Éditeur de thème : une section rechargée est réinitialisée et affichée telle quelle.
  d.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    initSticky();
    all('[data-reveal], [data-split], [data-imx-print], [data-imx-feed]', e.target).forEach(function (el) {
      el.classList.add('is-in', 'is-printed');
    });
  });
})();
